module.exports = __webpack_public_path__ + "img/ibm_cloud.c2a44361.png";